import React from 'react'
import { Menu } from 'antd';
import {
    ShopOutlined,
    ShoppingOutlined,
    FileSyncOutlined,
    FileSearchOutlined,
    AccountBookOutlined,
    FlagOutlined,
} from '@ant-design/icons';
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { switchMenu } from './../../redux/action'
import MenuConfig from './../../config/menuConfig'
import './index.less'

import {IMAGE_PATH} from "../../constants";

const SubMenu = Menu.SubMenu;
class NavLeft extends React.Component {
    state = {
        currentKey: ''
    }
    // 菜单点击
    handleClick = ({ item, key }) => {
        if (key == this.state.currentKey) {
            return false;
        }
        // 事件派发，自动调用reducer，通过reducer保存到store对象中
        const { dispatch } = this.props;
        dispatch(switchMenu(item.props.title));

        this.setState({
            currentKey: key
        });
        // hashHistory.push(key);
    };
    componentWillMount(){
        let menuTreeNode = this.renderMenu(MenuConfig);
        this.setState({
            menuTreeNode
        })
    }
    // 菜单渲染
    renderMenu =(data)=>{
        return data.map((item)=>{
            if(item.children){
                return (
                    <SubMenu title={item.title} key={item.key} icon={<ShopOutlined />}>
                        { this.renderMenu(item.children)}
                    </SubMenu>
                )
            }
            return <Menu.Item title={item.title} key={item.key}
                              icon={
                                      item.title==='财务对账'? <AccountBookOutlined /> :
                                          item.title==='店信息'? <ShopOutlined /> :
                                              item.title==='配送管理'? <FlagOutlined /> :
                                          item.title==='商品管理'? <ShoppingOutlined /> :
                                              item.title==='订单'? <FileSyncOutlined /> :
                                                      item.title==='营业账单'? <FileSearchOutlined /> : null}>
                <NavLink to={item.key}>{item.title}</NavLink>
            </Menu.Item>
        })
    }
    homeHandleClick = () => {
        const { dispatch } = this.props;
        dispatch(switchMenu('首页'));
        this.setState({
            currentKey: ""
        });
    };
    render() {
        return (
            <div>
                {/*<NavLink to="/home" onClick={this.homeHandleClick}>*/}
                    <div className="top-bg">
                        <img className="top-bg-img" src={IMAGE_PATH + "/assets/favicon-logo.png"} alt="" />
                        <span style={{color: '#ffffff', fontSize: 18, marginLeft: '3px', fontWeight: 'bold'}}>寻梦商户</span>
                    </div>
                {/*</NavLink>*/}
                <Menu
                    onClick={this.handleClick}
                    theme="dark"
                    mode="inline"
                >
                    { this.state.menuTreeNode }
                </Menu>
            </div>
        );
    }
}
export default connect()(NavLeft)



// WEBPACK FOOTER //
// ./src/components/NavLeft/index.js